import { TenantModel } from '@kaiser-software/chassis-core';

export class LocationModel extends TenantModel {

    public parent_id: number;
    public name: string;

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/locations/models/location.model.ts